import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Shivakumar H M </span>
            from <span className="purple"> Tumkur.</span>
            <br />
            I am currently employed as a Software Developer at Incture Technologies.
            <br />
            I completed my B.Tech at Alva's Institute of Engineering and Technology, specializing in Computer Science.
            <br />
            <br />
            Apart from this, here are some of my extracurricular activities:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> National Cadet Corps (NCC)
            </li>
            <li className="about-activity">
              <ImPointRight /> Sports
            </li>
            <li className="about-activity">
              <ImPointRight /> Trekking
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
